import { render, staticRenderFns } from "./grid-list.vue?vue&type=template&id=b868e1c0&"
import script from "./grid-list.ts?vue&type=script&lang=js&"
export * from "./grid-list.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports